 
<div class="popover" [ngClass]="context === 'triage' ? 'triage-popover' : 'backlog-popover'">  
    <div class="popover-content">
      <!-- Libellés disponibles -->
      <div class="assignee-group">
        @for(assignee of managers; track assignee.id){
          <div class="assignee-item w-100" [ngClass]="setSelectedClass(assignee)">
              <div class="d-flex align-items-center" (click)="toggleAssignee(assignee)">
                <div>
                  <i class="fa-regular fa-square pe-2"></i>
                  <i class="fa-regular fa-square-check pe-2"></i>
                </div>
                <div>
                  {{ assignee.firstname }} {{ assignee.lastname }}
                </div>
              </div>
          </div>
        }
      </div>
    </div>
</div>
   